import { Icon } from "../components/Icon";
import { PhoneFrame } from "../components/PhoneFrame";
import { SectionHeading } from "../components/SectionHeading";
import { SCREENS } from "../data/screens";
import { RichText, useSiteTranslation } from "../i18n";
import floral from "../../../pictures/home/floral.png";
import maryam from "../../../pictures/home/maryam.jpg";
import zain from "../../../pictures/home/zain.jpg";
import fatima from "../../../pictures/home/fatima.jpg";
import "../styles/islamic.css";

// One icon per entry in home.islamic.items: guidance and hadith, the Qur'an, Islamic Shorts.
const ITEM_ICONS = ["moon", "book", "play"];

// Profiles seen while browsing, before the feed shows a reminder in place of an ad.
const FEED_PROFILES = [maryam, zain, fatima];

/** How the feed works: a hadith or short Islamic video appears every few profiles instead of an ad. */
function ReminderFeed() {
  const { t } = useSiteTranslation();

  return (
    <div className="islamic-feed" data-reveal>
      <div className="islamic-feed-copy">
        <p className="eyebrow">{t("home.islamic.feed.eyebrow")}</p>
        <h3>{t("home.islamic.feed.title")}</h3>
        <p>{t("home.islamic.feed.text")}</p>
      </div>

      {/* Illustration only: the copy above describes it. */}
      <ol className="islamic-feed-strip" aria-hidden="true">
        {FEED_PROFILES.map((src) => (
          <li className="feed-tile feed-tile--profile" key={src}>
            <img src={src} alt="" />
            <span>{t("home.islamic.feed.profile")}</span>
          </li>
        ))}
        <li className="feed-tile feed-tile--reminder">
          <Icon name="moon" />
          <small>{t("home.islamic.feed.reminder")}</small>
          <p>{t("home.islamic.feed.reminderText")}</p>
          <cite>{t("home.islamic.feed.reminderSource")}</cite>
        </li>
      </ol>
    </div>
  );
}

/** The app's Islamic Corner: daily hadith and guidance, the Qur'an, and short Islamic reels. */
export function IslamicCornerSection() {
  const { t } = useSiteTranslation();
  const items = t("home.islamic.items", { returnObjects: true });

  return (
    <section className="section islamic" id="islamic">
      <img className="islamic-floral" src={floral} alt="" aria-hidden="true" />
      <div className="wrap">
        <SectionHeading
          layout="split"
          eyebrow={t("home.islamic.eyebrow")}
          title={<RichText k="home.islamic.title" />}
          lead={t("home.islamic.lead")}
        />

        <div className="islamic-layout">
          <div className="islamic-visual" data-reveal>
            <div className="islamic-orbit" aria-hidden="true" />
            <PhoneFrame className="islamic-phone islamic-phone--back" src={SCREENS.shorts.src} alt={t(SCREENS.shorts.alt)} />
            <PhoneFrame className="islamic-phone islamic-phone--front" src={SCREENS.guidance.src} alt={t(SCREENS.guidance.alt)} />
          </div>

          <div className="islamic-copy">
            <ul className="islamic-list">
              {items.map(({ title, text }, index) => (
                <li key={index} data-reveal style={{ "--delay": `${index * 0.08}s` }}>
                  <span className="islamic-icon">
                    <Icon name={ITEM_ICONS[index]} />
                  </span>
                  <div>
                    <h3>{title}</h3>
                    <p>{text}</p>
                  </div>
                </li>
              ))}
            </ul>

            <figure className="islamic-hadith" data-reveal>
              <Icon name="moon" className="islamic-hadith-moon" />
              <blockquote>{t("home.islamic.hadith")}</blockquote>
              <figcaption>{t("home.islamic.hadithSource")}</figcaption>
            </figure>
          </div>
        </div>

        <ReminderFeed />
      </div>
    </section>
  );
}
